import { render } from "./AppDynamicIconHeader.vue?vue&type=template&id=3db352bc&scoped=true&ts=true"
import script from "./AppDynamicIconHeader.vue?vue&type=script&lang=ts"
export * from "./AppDynamicIconHeader.vue?vue&type=script&lang=ts"

import "./AppDynamicIconHeader.vue?vue&type=style&index=0&id=3db352bc&lang=scss&scoped=true"
import "./AppDynamicIconHeader.vue?vue&type=style&index=1&id=3db352bc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db352bc"]])

export default __exports__